import { render, staticRenderFns } from "./PersonalRecordAnimation.vue?vue&type=template&id=2e274dca&scoped=true"
import script from "./PersonalRecordAnimation.vue?vue&type=script&lang=js"
export * from "./PersonalRecordAnimation.vue?vue&type=script&lang=js"
import style0 from "./PersonalRecordAnimation.vue?vue&type=style&index=0&id=2e274dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e274dca",
  null
  
)

export default component.exports